export default __webpack_public_path__ + "static/media/SOLID.bf971fcd.webp";